<template>
    <div class="responses">
        <List v-if="list" :DB="list" @emit="emit" />
    </div>
</template>

<script>

import WebSoc from '../utils/WebSoc.js'
import List from '../components/List.vue'
import { format } from 'date-fns'

export default {
    props: [ 'survey_id' ],
    components: {
        List
    },
    data () {
        return {
            items: [],
            db: '',
            list: false,
            "5f8eb92e3b944d20b9954e60-responses": {
                list: {
                    t: 'responses-list',
                    DB: "5f8eb92e3b944d20b9954e60-responses",
                    title: 'Survey Responses',
                    downloadTitle: 'App Responses',
                    watch: {},
                    fields: [
                        { title: 'Date', field: 'created', class: 'td-ulb', width: 150, map: item => format(item.created,'dd/MM/yy HH:mm') },
                        { title: 'Name', field: 'name', class: 'td-ulb', width: 300 },
                        { title: 'Secure', field: 'resp.hDU7N', class: 'ta-r', width: 110, map: item => item.resp['hDU7N'] || '' },
                        { title: 'Status', field: 'resp.k12VA', class: 'ta-r', width: 110, map: item => item.resp['k12VA'] || '' },
                        { title: 'Control', field: 'resp.kuZvs', class: 'ta-r', width: 110, map: item => item.resp['kuZvs'] || ''},
                        { title: 'Relations', field: 'resp.PfIOi', class: 'ta-r', width: 110, map: item => item.resp['PfIOi'] || ''},
                        { title: 'Creative', field: 'resp.of8lx', class: 'ta-r', width: 110, map: item => item.resp['of8lx'] || ''},
                        { title: 'Wellbeng', field: 'resp.nYMTu', class: 'ta-r', width: 110, map: item => item.resp['nYMTu'] || ''},
                        { title: 'Purpose', field: 'resp.24Bqp', class: 'ta-r', width: 110, map: item => item.resp['24Bqp'] || ''},
                        { title: 'Score', field: 'resp.zgzwK', class: 'ta-r', width: 110, map: item => item.resp['zgzwK'] || ''},
                    ],
                    filter: { hasResponse: true }
                }
            },
            "5f8d8c7f3b944d20b9954e20-responses": {
                list: {
                    t: 'responses-list',
                    DB: "5f8d8c7f3b944d20b9954e20-responses",
                    title: 'Survey Responses',
                    downloadTitle: 'Form Responses',
                    watch: {},
                    fields: [
                        { title: 'Date', field: 'created', class: 'td-ulb', width: 150, map: item => format(item.created,'dd/MM/yy HH:mm') },
                        { title: 'Name', field: 'resp.J8Drn', class: 'ellip', width: '0.6fr', map: item => item.resp['J8Drn'] },
                        { title: 'Code', field: 'resp.4MKjD', class: 'ellip', width: '0.5fr', map: item => item.resp['4MKjD'] },
                        { title: 'Email', field: 'resp.ifWfq', class: 'ellip', width: '1fr', map: item => item.resp['ifWfq'] && (item.resp['ifWfq']+'').toLowerCase() },
                        { title: 'Mobile', field: 'resp.FKq59', class: 'ellip', width: '0.6fr', map: item => item.resp['FKq59'] },
                        { title: 'Secure', field: 'resp.XXtOh', class: 'ta-r', width: 110, map: item => item.resp['XXtOh'] },
                        { title: 'Status', field: 'resp.ZgABj', class: 'ta-r', width: 110, map: item => item.resp['ZgABj'] },
                        { title: 'Control', field: 'resp.fL8sp', class: 'ta-r', width: 110, map: item => item.resp['fL8sp']},
                        { title: 'Relations', field: 'resp.s6ojl', class: 'ta-r', width: 110, map: item => item.resp['s6ojl']},
                        { title: 'Creative', field: 'resp.FJ7sp', class: 'ta-r', width: 110, map: item => item.resp['FJ7sp']},
                        { title: 'Wellbeng', field: 'resp.GwH0J', class: 'ta-r', width: 110, map: item => item.resp['GwH0J']},
                        { title: 'Purpose', field: 'resp.YSMIL', class: 'ta-r', width: 110, map: item => item.resp['YSMIL']},
                        { title: 'Score', field: 'resp.aVD2M', class: 'ta-r', width: 110, map: item => item.resp['aVD2M']},
                    ],
                    filter: { hasResponse: true }
                }
            }
        }
    },
    mounted () {
        this.db = this.survey_id+'-responses';
        this.list = this[this.db].list
    },
    methods: {
        emit ( data ) {
            this.$emit('emit',data);
        }
    }
}

</script>